import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebaseConfig';
import { confirmApp } from '../common/appDialog';
import { mfaError } from '../common/mfa';
import { requestRecentMfa } from './mfaDialogs';
import { mfaStyles as styles } from './mfaStyles';

export default function MfaRecoveryForm({ initialEmail = '', disabled = false, onBusyChange }: {
    initialEmail?: string;
    disabled?: boolean;
    onBusyChange: (busy: boolean) => void;
}) {
    const [email, setEmail] = useState(initialEmail);
    const [reason, setReason] = useState('');
    const [verified, setVerified] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const recover = async (event: React.FormEvent) => {
        event.preventDefault();
        if (!await confirmApp(`Reset MFA for ${email}? All of their sessions will end, and fresh MFA setup will be required.`, { title: 'Verified account recovery', tone: 'danger', confirmLabel: 'Reset MFA' }))
            return;
        setBusy(true);
        onBusyChange(true);
        setError('');
        setMessage('');
        try {
            await requestRecentMfa();
            const response = await httpsCallable<{ email: string; reason: string; identityVerified: boolean }, { recoveryId: string; notificationSent: boolean }>(functions, 'resetUserMfa')({ email, reason, identityVerified: verified });
            setMessage(`MFA reset complete. Recovery ID: ${response.data.recoveryId}. ${response.data.notificationSent ? 'Account owner notified.' : 'Owner notification failed; contact the verified owner through your established channel.'}`);
            setEmail('');
            setReason('');
            setVerified(false);
        } catch (failure) {
            setError(mfaError(failure));
        } finally {
            setBusy(false);
            onBusyChange(false);
        }
    };
    return <div className="space-y-4">
        <p className={styles.text}>Confirm the person's identity through an established company contact or an in-person check. Email access alone is insufficient. Resets are recorded and the account owner is notified.</p>
        {error && <p role="alert" className={styles.error}>{error}</p>}
        {message && <p role="status" className={styles.notice}>{message}</p>}
        <form onSubmit={recover} className="space-y-4"><label className="block text-sm font-semibold">Account email<input autoFocus type="email" required className={styles.input} value={email} onChange={event => setEmail(event.target.value)} disabled={busy || disabled} /></label>
            <label className="block text-sm font-semibold">Reason and identity verification record<textarea required minLength={20} maxLength={1000} className={styles.input} value={reason} onChange={event => setReason(event.target.value)} disabled={busy || disabled} /></label>
            <label className="flex items-start gap-3 text-sm"><input type="checkbox" required checked={verified} onChange={event => setVerified(event.target.checked)} disabled={busy || disabled} /><span>I verified identity beyond email access and recorded the check above.</span></label>
            <button className={styles.button} disabled={busy || disabled || !verified}>{busy ? 'Verifying…' : 'Reset account MFA'}</button>
        </form>
    </div>;
}
